export enum UserStatus {
  OnWaitingList = 'WAITING_LIST',
  PendingApproval = 'PENDING_APPROVAL',
  Member = 'ACTIVE'
}
